declare global {
  interface Window {
    offlineModeStore: OfflineStore;
  }
}

type Listener = (value: boolean) => void;

interface OfflineStore {
  value: boolean;
  set(value: boolean, redirectUrl?: string): Promise<void>;
  subscribe(callback: Listener): () => void;
}

const offlineModeStore: OfflineStore = window.offlineModeStore;

function alpineData() {
  return {
    online: true,
    offlineMode: false,
    unsubscribe: null as (() => void) | null,
    globalLoader: null,

    init() {
      this.online = navigator.onLine;

      this.unsubscribe = offlineModeStore.subscribe((value) => {
        this.offlineMode = value;
      });
    },

    toggleOfflineMode() {
      this.offlineMode = !this.offlineMode;
      offlineModeStore.set(this.offlineMode);
    },

    async resetOfflineMode() {
      this.offlineMode = false;
      await offlineModeStore.set(false);
    },

    async activateOffline() {
      this.offlineMode = true;
      await offlineModeStore.set(true, `${window.location.origin}/home`);
    },
  };
}

export default alpineData;
